/* eslint-disable react/prop-types */
import React, { FunctionComponent } from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ButtonPropsWithoutRef } from "react-html-props";
import styled from "styled-components";
import Theme from "../../../theme/theme";
import { StyledButton, ButtonSize } from "./styles";
export interface ButtonProps extends ButtonPropsWithoutRef {
  primary?: boolean;
  secondary?: boolean;
  tertiary?: boolean;
  icon?: boolean;
  /**
   * Button will be centered relative to its parent element
   */
  centered?: boolean;
  disabled?: boolean;
  size?: ButtonSize;
}

export const Button: FunctionComponent<ButtonProps> = ({
  children,
  type = "button",
  onClick,
  name,
  primary,
  secondary,
  tertiary,
  centered,
  disabled,
  icon,
  id,
  size = "md",
}) => (
  <Theme>
    <StyledButton
      id={id}
      data-testid="buttom"
      aria-label={name}
      type={type}
      onClick={onClick}
      primary={primary}
      secondary={secondary}
      tertiary={tertiary}
      centered={centered}
      disabled={disabled}
      icon={icon}
      size={size}
    >
      {icon ? children : name ?? children}
    </StyledButton>
  </Theme>
);

Button.propTypes = {
  onClick: PropTypes.func,
  id: PropTypes.string,
  name: PropTypes.string,
  primary: PropTypes.bool,
  secondary: PropTypes.bool,
  tertiary: PropTypes.bool,
  centered: PropTypes.bool,
  icon: PropTypes.bool,
};

Button.defaultProps = {
  onClick: null,
  id: null,
  name: null,
  primary: null,
  secondary: null,
  tertiary: null,
  centered: null,
  icon: null,
};

export const ButtonIcon = styled(FontAwesomeIcon)`
  margin-right: 0.5rem;
`;

export default Button;
